const COLORS = {
    
};

export default COLORS;
